import React, { useState } from "react";
import ContactInfoBlock from "../ContactInfoBlock/ContactInfoBlock";
import ContactFormBlock from "../ContactFormBlock/ContactFormBlock";
import "./ContactCardSection.css";
import SoftCtaSection from "../SoftCtaSection/SoftCtaSection";

const ContactCardSection = ({ onFormSuccess }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", interest: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const requestData = {
        product: "VANIDYA_PROSPECT",
        prospectDetails: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: form.phone,
          interest: form.interest,
          message: form.message,
        }),
      };

      const response = await fetch("https://click.vanidya.com/content/prospect", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        console.error("Prospect API error:", response.status, response.statusText);
        return;
      }

      setSubmitted(true);
      if (onFormSuccess) onFormSuccess();
    } catch (err) {
      console.error("Prospect API failed:", err);
    }
  }

  return (
    <>
      <section className="contact-card-section">
        <div className="contact-card">
          <ContactInfoBlock />
          <ContactFormBlock
            form={form}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            submitted={submitted}
          />
        </div>
      </section>
    </>
  );
};

export default ContactCardSection;
